<template>
  <div>
    <page-title icon="fa fa-shopping-cart" main="Promoções" sub="Campanhas" :help="true" titleHelp="Ajuda - Ano Safra" content="Nesta página temos um Dashboard Geral">
    </page-title>
    <card>
      <div slot="header">
        <div class="row">
          <div class="col-md-12">
            <strong style="color:#2dce89;margin-right:16px">Campanha: {{campaign.name}}</strong>
          </div>
          <div class="col-md-12">
            <span>Descontos de Campanha</span>
          </div>
        </div>
      </div>
      <tabs
        tabNavClasses="nav-fill flex-column flex-sm-row nav-wrapper"
        tabContentClasses="card shadow"
      >
        <tab-pane id="quantity">
          <span slot="title">
            <i class="ni ni-cloud-upload-96" />
            Quantidade
          </span>
          <quantity-discounts :campaign.sync="campaign" />
        </tab-pane>

        <tab-pane id="brand">
          <span slot="title">
            <i class="ni ni-bell-55 mr-2" />
            Marcas
          </span>
          <brand-discounts :campaign.sync="campaign" />
        </tab-pane>

        <tab-pane id="general">
          <span slot="title">
            <i class="ni ni-calendar-grid-58" />
            Geral
          </span>
          <default-discounts :campaign.sync="campaign" />
        </tab-pane>

        <tab-pane id="thresholds">
          <span slot="title">
            <i class="ni ni-bag-17" />
            Volumes
          </span>
          <thresholds :campaign.sync="campaign" />
        </tab-pane>
      </tabs>
    </card>
  </div>
</template>
<script>
import Vue from "vue";
import PageTitle from "@/layouts/PageTitle";
import { Select, Option } from "element-ui";
import BrandDiscounts from "@/views/Campaigns/BrandDiscounts";
import QuantityDiscounts from "@/views/Campaigns/QuantityDiscounts";
import DefaultDiscounts from "@/views/Campaigns/DefaultDiscounts";
import Thresholds from "@/views/Campaigns/Thresholds";
import Tabs from "@/components/Tabs/Tabs";
import TabPane from "@/components/Tabs/Tab";

export default {
  name: "app",
  components: {
    Tabs,
    TabPane,
    BrandDiscounts,
    QuantityDiscounts,
    DefaultDiscounts,
    Thresholds,
    PageTitle,
  },
  data() {
    return {
      campaign: {},
    };
  },
  created() {
    this.setStaticData();
    // this.setData();
    // this.products = template_products;
  },
  methods: {
    setStaticData() {
      this.$http.secured
        .get(`/api/v1/campaigns/${this.$route.params.campaign_id}`)
        .then((response) => {
          this.campaign = response.data;
        })
        .catch((error) => this.setError(error, "failed to fetch branches"));
    },
    // newDiscount(){
    //   this.$root.$emit('new_discount', this.tabName)
    // }
  },
  computed: {
    campaign_id: function () {
      return this.$route.params.campaign_id;
    },
    tabName: function() {
      let el = this.$el.querySelectorAll('a.nav-link.active')[0];
      console.log("EL: ", el);
      console.log("EL HREF: ", el.href.toString());
      console.log("GENERAL: ", this.$el.querySelectorAll('a.nav-link.active'));
      console.log("SPPLITED: ", el.href.split["#"]);
      
      // let el = document.querySelector('a.nav-link.active');
      return el.href.toString().split("#")[1];
    },
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>


